import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  receiptsList: [],
  fraudSettings: {
    receipt_amount: 0,
    spending_amount: 0,
    multiple_receipts_store: 0,
    multiple_receipts_calender: 0
  },
  memberReceipts: [],
  receiptsRandomList: []
};

export const receiptsListSlice = createSlice({
  name: "receiptsListSlice",
  initialState,
  reducers: {
    updateReceiptsList(state, action) {
      state.receiptsList = action.payload.receiptsList;
    },
    updateFraudSettings(state, action) {
      state.fraudSettings.receipt_amount = action.payload.receiptAmount;
      state.fraudSettings.spending_amount = action.payload.spendingAmount;
      state.fraudSettings.multiple_receipts_store = action.payload.multipleReceiptsStore;
      state.fraudSettings.multiple_receipts_calender = action.payload.multipleReceiptsCalendar;
    },
    updateMemberReceipts(state, action) {
      state.memberReceipts = action.payload.memberReceipts;
    },
    updateReceiptsListRandom(state, action){
      state.receiptsRandomList = action.payload.receiptsRandomList;
    },
    resetReceiptsState: (state) => initialState,
  },
});
export const receiptsActions = receiptsListSlice.actions
export default receiptsListSlice.reducer;
